<template>
  <div style="width: 100%; height: auto">
    <td style="position: relative">
      <div>
        <img :src="img1" style="width: 100%" />
      </div>
      <div style="text-align: center">
        <img :src="img2" style="width: 104px; height: 104px" />
      </div>
      <div style="text-align: center">
        <img
          :src="img3"
          style="width: 204px; margin-top: 23px"
          title="ios download"
        />
      </div>
      <div style="text-align: center">
        <a
          href="https://apps.apple.com/app/kk-home/id1643651425"
          download="com.kkhome.kksecurity"
          style="
            display: block;
            color: #275cfd;
            border: 1px solid #386aff;
            border-radius: 50px;
            padding: 9px 1px;
            text-decoration: none;
            width: 172px;
            margin: 10px auto;
            font-size: 15px;
          "
        >
          Download for iOS
          <!--          <img :src="img4" style="margin-top: 20px; width: 150px;"/>-->
        </a>
      </div>
      <div style="text-align: center">
        <img
          :src="img5"
          style="width: 204px; margin-top: 80px"
          title="android download"
        />
      </div>
      <div style="text-align: center">
        <a
          href="https://play.google.com/store/apps/details?id=com.kkhome.kksecurity"
          download="com.revolo.lock"
          style="
            display: block;
            color: #275cfd;
            border: 1px solid #386aff;
            border-radius: 50px;
            padding: 9px 1px;
            text-decoration: none;
            width: 182px;
            margin: 10px auto;
            font-size: 15px;
          "
        >
          Download for Android
          <!--            <img :src="img6" style="margin-top: 20px; width: 150px;"/>-->
        </a>
      </div>
    </td>
  </div>
</template>

<script>
export default {
  data() {
    return {
      msg: "KK Home App Download",
      // 背景图片
      img1: require("../../assets/kawden/download/bg_down_top.png"),
      img2: require("../../assets/kawden/download/ic_launcher_round.png"),
      img3: require("../../assets/kawden/download/iOS_qrCode.png"), // ios下载地址
      img4: require("../../assets/kawden/download/icon_down_iOS.png"),
      img5: require("../../assets/kawden/download/android_qrCode.png"), // 安卓下载地址
      img6: require("../../assets/kawden/download/icon_down_android.png"),
    };
  },
  created() {},
  mounted() {},
  methods: {
    // handleClick () {
    //   window.location.href = this.appurl // windows.location.href="/url" 唤醒app
    //   // MessageBox.alert(this.appurl, "this.appurl");
    // },
    // handleDownload () {
    //   window.location.href = this.downloadurl
    // }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
  margin: 0;
  padding: 0;
}
</style>


// WEBPACK FOOTER //
// src/view/download/kawden.vue